import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {PoiGroup} from '../../../shared/models/poi-group';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable()
export class PoiGroupService {

  private _poiGroups: BehaviorSubject<PoiGroup[]>;

  constructor(
    private http: HttpClient
  ) {
    this._poiGroups = new BehaviorSubject<PoiGroup[]>(null);
  }

  getPoiGroups(customerId: number): Observable<PoiGroup[]> {
    const url = `/webofficerpc/rest-endpoint/FeesOffice/poiGroup?customerId=${customerId}`;

    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.http.get<PoiGroup[]>(url, {headers})
      .pipe(
        map((poiGroups: PoiGroup[]) => {
          this._poiGroups.next(poiGroups);

          return poiGroups;
        })
      );
  }
}
